import { io as IOConnect } from 'socket.io-client'
import { useEffect } from 'react'

export const token = localStorage.getItem('amber-auth-token')?.replace(/"/g, '')
const socketUrl = process.env.NODE_ENV === 'development' ? '10.10.11.112' : window.location.hostname

const socket = IOConnect(socketUrl, {
  extraHeaders: {
    authorization: `Bearer ${ token }`,
  },
})

function initSocket() {
  if (typeof window === 'undefined' || !!socket) return

  socket.on('connect_error', (error) => {
    console.error('Ошибка подключения:', error.message)
    setTimeout(() => {
      console.log('Повторная попытка подключения...')
      socket.connect()
    }, 10000)
  })

  socket.on('connect', (res) => {
    console.log('Соединение установлено успешно')
  })
}

initSocket()
export default function useSocket(channel, cb) {
  useEffect(() => {
    if (!channel || !cb) return

    socket.on(channel, cb)

    return () => {
      socket.off(channel, cb)
    }
  }, [channel, cb])

  return socket
}
